import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import NotificationCategoryList from 'components/NotificationCategory/List';

const ScreenNotificationCategoryList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <NotificationCategoryList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenNotificationCategoryList;
